<template>
  <div class="modal fixed">
    <div class="modal-content">
      <button class="modal-button" @click="gotClose(true)">
        <BaseIcon name="window-close" class="icon" />
      </button>
      <h2 class="modal-title">Detail Overview</h2>
      <LotDetail v-if="selectedItem.LOT != undefined" :item="selectedItem"/>
      <BonDetail v-if="selectedItem.BON != undefined" :item="selectedItem"/>
      <RawMatDetail v-if="selectedItem.rawMaterialID != undefined && selectedItem.flowID == undefined" :item="selectedItem"/>
      <FlowDetail v-if="selectedItem.flowID != undefined && selectedItem.rawMaterialID == undefined" :item="selectedItem"/>
      <StepDetail v-if="selectedItem.stepID != undefined" :item="selectedItem"/>
      <DevicesDetail v-if="selectedItem.flowID != undefined" :item="selectedItem"/>
      <DHRDetail v-if="selectedItem.DHRID != undefined" :item="selectedItem"/>
    </div>
  </div>
</template>

<script>
import LotDetail from "@/components/modal-detail/LotDetail";
import BonDetail from "@/components/modal-detail/BonDetail";
import RawMatDetail from "@/components/modal-detail/RawMatDetail";
import FlowDetail from "@/components/modal-detail/FlowDetail";
import StepDetail from "@/components/modal-detail/StepDetail";
import DevicesDetail from "@/components/modal-detail/DevicesDetail";
import DHRDetail from "@/components/modal-detail/DHRDetail";

import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseIcon,
    LotDetail,
    BonDetail,
    RawMatDetail,
    FlowDetail,
    StepDetail,
    DevicesDetail,
    DHRDetail,
  },
  props: {
    selectedItem: Object
  },
  data() {
    return {
    }
  },
  created() {
    let that = this;
    document.addEventListener('keyup', function (evt) {
      if (evt.keyCode === 27) {
        that.gotClose(true);
      }
    });
  },
  mounted() {
    this.currentRoute = this.$router.currentRoute.name
  },
  methods: {
    gotClose(val) {
      this.$emit('closeModal', val);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";

.fixed {
  position: fixed;
  left: 0;
  top: 0;
}
</style>
